import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-picture-card',
    templateUrl: './picture-card.component.html',
    styleUrls: ['./picture-card.component.scss'],
    standalone: false
})
export class PictureCardComponent {

    @Input() public src: string;

    @Input() public canRemove = false;
    @Input() public canFullscreen = false;

    /**
     * Picture-card always renders at grid/list dimensions, so requests
     * the BE's 300px companion thumbnail (generated alongside the
     * original by FilesStorageServiceImpl.save) rather than the
     * full-size original. The BE falls back transparently to the
     * original when no thumbnail exists, so this is safe for older
     * uploads that pre-date the thumbnail pipeline.
     *
     * Fullscreen viewers stay on the original URL — they build their
     * own URL from `image.fileName` directly rather than reading
     * `src` off this component.
     */
    public get displaySrc(): string {
        if (!this.src) {
            return this.src;
        }
        try {
            const url = new URL(this.src, window.location.origin);
            url.searchParams.set('thumb', 'true');
            return url.toString();
        } catch {
            // Malformed URL — fall through with a query-string append.
            const separator = this.src.includes('?') ? '&' : '?';
            return `${this.src}${separator}thumb=true`;
        }
    }

}
